module.exports = __webpack_public_path__ + "img/manungo.13245f84.png";